var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 807.44,
    height: 710.345,
    viewBox: "0 0 807.44 710.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404_Error_Page_not_Found_with_people_connecting_a_plug-rafiki",
    "data-name": "404 Error Page not Found with people connecting a plug-rafiki",
    transform: "translate(-104.187 -102.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-36",
    transform: "translate(0 72.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1591",
    "data-name": "Rect\\xE1ngulo 1591",
    width: 62.699,
    height: 0.497,
    transform: "translate(830.816 669.133)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1592",
    "data-name": "Rect\\xE1ngulo 1592",
    width: 66.353,
    height: 0.497,
    transform: "translate(599.642 663.751)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1593",
    "data-name": "Rect\\xE1ngulo 1593",
    width: 123.988,
    height: 0.497,
    transform: "translate(787.639 687.583)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1594",
    "data-name": "Rect\\xE1ngulo 1594",
    width: 38.191,
    height: 0.497,
    transform: "translate(104.187 684.247)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1595",
    "data-name": "Rect\\xE1ngulo 1595",
    width: 60.157,
    height: 0.497,
    transform: "translate(160.074 684.247)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1596",
    "data-name": "Rect\\xE1ngulo 1596",
    width: 108.358,
    height: 0.497,
    transform: "translate(376.512 675.866)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6667",
    "data-name": "Trazado 6667",
    d: "M328.444,118.13,215.28,231.314V608.242H612.466V118.13Z",
    transform: "translate(212.272 7.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6668",
    "data-name": "Trazado 6668",
    d: "M613.008,609.857H215.8a1.072,1.072,0,0,1-1.072-1.072V231.856a1.052,1.052,0,0,1,.318-.755l113.2-113.2a1.132,1.132,0,0,1,.755-.318h284a1.072,1.072,0,0,1,1.073,1.072V608.785a1.073,1.073,0,0,1-1.073,1.073Zm-396.114-2.125H611.936V119.745H329.443L216.895,232.293Z",
    transform: "translate(211.73 6.706)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6669",
    "data-name": "Trazado 6669",
    d: "M215.28,231.314l118.745,15.312-5.581-128.5Z",
    transform: "translate(212.272 7.248)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6670",
    "data-name": "Trazado 6670",
    d: "M215.28,231.314H328.444V118.13Z",
    transform: "translate(212.272 7.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6671",
    "data-name": "Trazado 6671",
    d: "M329,232.906h-113.2a1.072,1.072,0,0,1-.993-.655,1.033,1.033,0,0,1,.238-1.152l113.2-113.2a1.112,1.112,0,0,1,1.172-.238,1.092,1.092,0,0,1,.655.993v113.2A1.072,1.072,0,0,1,329,232.906Zm-110.582-2.125h109.53V121.251Z",
    transform: "translate(211.719 6.708)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6672",
    "data-name": "Trazado 6672",
    d: "M385.544,304.486l67.525-67.525a16.248,16.248,0,1,0-22.978-22.978l-67.525,67.525-67.525-67.525a16.248,16.248,0,0,0-22.978,22.978l67.525,67.525-67.525,67.525a16.248,16.248,0,0,0,22.978,22.978l67.525-67.525,67.525,67.525a16.248,16.248,0,1,0,22.978-22.978Z",
    transform: "translate(263.569 97.069)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6673",
    "data-name": "Trazado 6673",
    d: "M269.61,275.62h0a20.317,20.317,0,0,1-28.718,0L175.73,210.438l28.718-28.718,65.162,65.261A20.317,20.317,0,0,1,269.61,275.62Z",
    transform: "translate(173.275 69.95)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6674",
    "data-name": "Trazado 6674",
    d: "M0,0H40.614V3.754A14.677,14.677,0,0,1,25.938,18.43H14.677A14.677,14.677,0,0,1,0,3.754Z",
    transform: "translate(348.998 280.514) rotate(-45)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6675",
    "data-name": "Trazado 6675",
    d: "M105.19,111.24a141.008,141.008,0,1,0,99.758-41.351A141.008,141.008,0,0,0,105.19,111.24ZM296.564,302.614a129.549,129.549,0,1,1,0-183.211,129.549,129.549,0,0,1,0,183.211Z",
    transform: "translate(63.047 -40.319)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6676",
    "data-name": "Trazado 6676",
    d: "M174.7,259.048a4.727,4.727,0,0,1-3.336-8.063,100.255,100.255,0,0,0,0-141.584,4.727,4.727,0,1,1,6.673-6.673,109.669,109.669,0,0,1,0,154.91,4.727,4.727,0,0,1-3.337,1.41Z",
    transform: "translate(167.409 -9.504)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6677",
    "data-name": "Trazado 6677",
    d: "M87.319,200.908a4.707,4.707,0,0,1-4.588-3.634,109.966,109.966,0,0,1,15.094-85.618,4.748,4.748,0,0,1,7.944,5.2,100.592,100.592,0,0,0-13.9,78.25,4.687,4.687,0,0,1-3.5,5.68A5.245,5.245,0,0,1,87.319,200.908Z",
    transform: "translate(78.673 -1.253)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6678",
    "data-name": "Trazado 6678",
    d: "M109.872,199.153a4.727,4.727,0,0,1-3.337-1.39,108.834,108.834,0,0,1-20.853-29.075,4.716,4.716,0,1,1,8.46-4.171,100.314,100.314,0,0,0,19.066,26.573,4.727,4.727,0,0,1,0,6.673,4.786,4.786,0,0,1-3.337,1.39Z",
    transform: "translate(84.005 50.391)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6679",
    "data-name": "Trazado 6679",
    d: "M.02,0H26.275V60.971A11.757,11.757,0,0,1,14.518,72.729H11.757A11.757,11.757,0,0,1,0,60.971V0Z",
    transform: "translate(419.103 527.092) rotate(45)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6680",
    "data-name": "Trazado 6680",
    d: "M.04,0H26.255V1.251A10.665,10.665,0,0,1,15.59,11.916H10.665A10.665,10.665,0,0,1,0,1.251V0Z",
    transform: "translate(419.117 527.117) rotate(45)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6681",
    "data-name": "Trazado 6681",
    d: "M309.586,269.7l-43.494,43.474a27.288,27.288,0,0,0,38.589,38.549l17.6-17.576A93.483,93.483,0,0,0,309.586,269.7Z",
    transform: "translate(255.141 156.701)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6682",
    "data-name": "Trazado 6682",
    d: "M383.09,332.993a91.238,91.238,0,1,0-84.684,97.315A91.238,91.238,0,0,0,383.09,332.993ZM208.5,345.148A83.771,83.771,0,1,1,297.87,422.9,83.771,83.771,0,0,1,208.5,345.148Z",
    transform: "translate(198.022 135.352)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6683",
    "data-name": "Trazado 6683",
    d: "M235.409,346.676a70.663,70.663,0,0,1-24.21-48.5,3.058,3.058,0,1,1,6.1-.417,64.824,64.824,0,0,0,68.995,60.077,3.046,3.046,0,1,1,.417,6.077,70.564,70.564,0,0,1-51.3-17.239Z",
    transform: "translate(208.23 181.429)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6684",
    "data-name": "Trazado 6684",
    d: "M295.908,309.394a3,3,0,0,1-.934-1.49,64.983,64.983,0,0,0-32.313-39.919,3.059,3.059,0,0,1,2.82-5.422,71.14,71.14,0,0,1,35.371,43.693,3.039,3.039,0,0,1-2.125,3.754,3.1,3.1,0,0,1-2.82-.616Z",
    transform: "translate(257.479 149.379)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6685",
    "data-name": "Trazado 6685",
    d: "M243.906,263.877a3.1,3.1,0,0,1-1.033-2.105,3.058,3.058,0,0,1,2.82-3.257,71.261,71.261,0,0,1,23.038,2.165,3.081,3.081,0,0,1-1.569,5.958,64.5,64.5,0,0,0-21.032-1.986A3.138,3.138,0,0,1,243.906,263.877Z",
    transform: "translate(239.473 145.503)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-36",
    transform: "translate(111.436 767.483)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-36",
    cx: 385.071,
    cy: 22.482,
    rx: 385.071,
    ry: 22.482,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-36",
    transform: "translate(136.413 233.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6686",
    "data-name": "Trazado 6686",
    d: "M141.182,155.325c-16.007,16.107,11.2,41.111-6.772,52.59,14.677,7.368,66.115,16.722,79.441-12.254-9.712-7.547-2.959-26.1-11.916-43.911C188.529,125.336,125.175,137.033,141.182,155.325Z",
    transform: "translate(-3.881 -136.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6687",
    "data-name": "Trazado 6687",
    d: "M145.424,145.7c-4.985-.834-21.846,7.547-9.295,30.049,10.109,18.192,1.688,19.483,1.688,19.483s9.93.278,3.972-13.247C135.474,167.544,132.515,152.57,145.424,145.7Z",
    transform: "translate(-6.673 -127.092)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6688",
    "data-name": "Trazado 6688",
    d: "M232.181,248.823a4.886,4.886,0,0,0-6.554-1.986l-1.172.616c-.377.2-1.092.675-1.668,1.013s-1.251.715-1.887,1.033a30.87,30.87,0,0,1-3.873,1.629,24.387,24.387,0,0,1-7.646,1.45,20.992,20.992,0,0,1-7.05-1.132,25.342,25.342,0,0,1-4.151-1.986c-1.708-3.773-3.337-7.587-4.727-11.519-1.688-4.588-3.178-9.275-4.488-14.021s-2.463-9.553-3.416-14.379c-.5-2.4-.933-4.826-1.331-7.229l-.536-3.595c-.179-1.152-.338-2.463-.437-3.376v-.4a9.98,9.98,0,0,0-19.86,1.986c.139,1.688.258,2.979.437,4.389s.377,2.761.576,4.131c.437,2.741.933,5.442,1.49,8.143a152.674,152.674,0,0,0,4.171,15.888c.775,2.622,1.728,5.2,2.622,7.805s1.986,5.144,3.118,7.666a143.714,143.714,0,0,0,7.368,14.875l.238.437a7.726,7.726,0,0,0,3.078,3.058,40.236,40.236,0,0,0,12.016,4.25,33.425,33.425,0,0,0,13.028-.278,34.358,34.358,0,0,0,16.067-8.719,16.371,16.371,0,0,0,1.986-2.105c.556-.735,1.231-1.43,1.986-2.463a4.886,4.886,0,0,0,.616-5.184Z",
    transform: "translate(24.64 -87.342)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6689",
    "data-name": "Trazado 6689",
    d: "M214.629,208.251h-.576a12.373,12.373,0,0,0-9.93,4.647l-9.593,12.035v8.222c7.706,3.059,17.477-5.184,17.477-5.184l4.945-1.251a6.931,6.931,0,0,0,5.184-7.706l-.715-4.826A6.911,6.911,0,0,0,214.629,208.251Z",
    transform: "translate(55.399 -65.36)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6690",
    "data-name": "Trazado 6690",
    d: "M185.8,186.747c6.415,6.594,6.812,26.275,6.812,26.275l-25.659,20.655s-10.546-29.195-4.707-39.5C167.19,185.436,177.617,178.346,185.8,186.747Z",
    transform: "translate(21.828 -90.269)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5296",
    "data-name": "Grupo 5296",
    transform: "translate(182.311 92.718)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6691",
    "data-name": "Trazado 6691",
    d: "M185.8,186.747c6.415,6.594,6.812,26.275,6.812,26.275l-25.659,20.655s-10.546-29.195-4.707-39.5C167.19,185.436,177.617,178.346,185.8,186.747Z",
    transform: "translate(-160.483 -182.987)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6692",
    "data-name": "Trazado 6692",
    d: "M151.85,426.809l14.18,1.549,1.946-38.529L153.8,388.26Z",
    transform: "translate(13.316 112.137)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6693",
    "data-name": "Trazado 6693",
    d: "M169.646,403.79H152.983A1.291,1.291,0,0,0,151.652,405l-1.112,15.749a3.158,3.158,0,0,0,3.078,3.158H193.16c7.269,0,7.289-7.368,4.151-8.043-14.121-2.979-19.622-7.11-24.607-11.042A4.965,4.965,0,0,0,169.646,403.79Z",
    transform: "translate(12.024 127.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6694",
    "data-name": "Trazado 6694",
    d: "M167.553,389.839,166.54,409.7H152.28l1.092-21.429Z",
    transform: "translate(13.74 112.147)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6695",
    "data-name": "Trazado 6695",
    d: "M188.412,237.425s12.274,102.737,12.274,148.416c-9.672,63.553-17.874,175.088-17.874,175.088l-19.622-.516s-8.917-121.466-.655-173.917C151.948,339.507,138.88,231.07,138.88,231.07Z",
    transform: "translate(0.527 -42.857)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6696",
    "data-name": "Trazado 6696",
    d: "M148.142,248.67a58.6,58.6,0,0,0-6.792,3.535c2.7,20.277,6.256,45.8,10.029,69.352C157.814,302.174,154.339,259.553,148.142,248.67Z",
    transform: "translate(2.962 -25.503)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6697",
    "data-name": "Trazado 6697",
    d: "M74.53,405.989l11.7,8.163,20.178-32.889-11.7-8.163Z",
    transform: "translate(-62.924 97.189)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6698",
    "data-name": "Trazado 6698",
    d: "M94.949,398.509l-9.93-13.366a1.271,1.271,0,0,0-1.748-.338l-13.306,8.54a3.138,3.138,0,0,0-.7,4.349c4.151,5.66,4.23,5.7,9.453,12.73,3.237,4.31,9.692,12.989,14.141,18.967s10.268,1.45,8.917-1.49c-5.958-13.088-5.958-19.86-5.839-26.3a5.045,5.045,0,0,0-.993-3.1Z",
    transform: "translate(-68.686 108.522)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6699",
    "data-name": "Trazado 6699",
    d: "M101.949,381.263,91.562,398.223,79.03,391.391,90.271,373.1Z",
    transform: "translate(-58.487 97.189)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6700",
    "data-name": "Trazado 6700",
    d: "M126.369,508.781c-10.149,0-31.28,0-31.637-14.935-.278-11.718,14.22-16.583,26.732-17.179a10.566,10.566,0,0,1,11.062,10.049v.794c14.18-.675,23.356-3.773,26.712-9.056,7.567-11.916-6.931-42.68-20.933-72.411-16.484-34.974-35.153-74.6-35.51-112.548a10.566,10.566,0,0,1,10.466-10.665h0A10.586,10.586,0,0,1,123.827,293.3c.318,33.326,17.874,70.723,33.484,103.73,17.874,38.092,33.465,71,19.662,92.748C168.97,502.564,152.386,508.781,126.369,508.781Z",
    transform: "translate(-43.008 8.18)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6701",
    "data-name": "Trazado 6701",
    d: "M231.7,236.6S197.815,354.017,181.271,396.6c-32.055,55.728-85.24,141.008-85.24,141.008l-16.981-9.93s39.721-98.507,66.433-144.384c7.17-47.665,34.279-153.441,34.279-153.441Z",
    transform: "translate(-58.467 -44.06)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6702",
    "data-name": "Trazado 6702",
    d: "M84.808,399.193a5.66,5.66,0,0,0,2.939,2.4,1.986,1.986,0,0,0,1.986-.655,1.39,1.39,0,0,0,.437-1.211c-.238-2.383-6.4-5.481-7.626-6.077a.318.318,0,0,0-.4.139.457.457,0,0,0,0,.5,29.354,29.354,0,0,0,2.661,4.905Zm4.23,0a1.649,1.649,0,0,1,.338.755.477.477,0,0,1-.159.417,1.37,1.37,0,0,1-1.311.437c-1.311-.258-3.039-2.383-4.707-5.74a20.932,20.932,0,0,1,5.839,4.052Z",
    transform: "translate(-55.487 117.43)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6703",
    "data-name": "Trazado 6703",
    d: "M82.1,395.47l.119.1c1.986,1.092,7.15,1.986,8.282.338a1.728,1.728,0,0,0-.1-1.986c-1.986-3.515-7.944.616-8.2.794a.477.477,0,0,0-.179.4.655.655,0,0,0,.079.357Zm7.547-1.152a1.99,1.99,0,0,1,.159.218c.218.377.258.655.139.814-.655.953-4.469.616-6.693-.258C84.742,394.2,88.217,392.392,89.647,394.319Z",
    transform: "translate(-55.54 116.326)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6704",
    "data-name": "Trazado 6704",
    d: "M167.976,407.571a5.74,5.74,0,0,0,3.694-.934,1.986,1.986,0,0,0,.616-1.986,1.489,1.489,0,0,0-.715-1.092c-1.986-1.211-8.2,1.867-9.414,2.5a.338.338,0,0,0-.159.4.536.536,0,0,0,.377.338A27.666,27.666,0,0,0,167.976,407.571Zm2.463-3.436a1.509,1.509,0,0,1,.814.179c.1,0,.2.139.238.377a1.351,1.351,0,0,1-.437,1.311c-.973.894-3.714,1.013-7.408.358a20.693,20.693,0,0,1,6.693-2.224Z",
    transform: "translate(23.306 126.946)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6705",
    "data-name": "Trazado 6705",
    d: "M162.426,408.828h.139c1.986-.914,5.859-4.548,5.223-6.435a1.728,1.728,0,0,0-1.589-1.053c-3.972-.457-4.25,6.733-4.27,7.031a.446.446,0,0,0,.5.457ZM166,402.075h.278c.417,0,.675.179.735.377.377,1.092-2.165,3.972-4.21,5.223.179-1.728.814-5.6,3.237-5.6Z",
    transform: "translate(23.255 125.014)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6706",
    "data-name": "Trazado 6706",
    d: "M129.76,281.065l67.644,8.659c15.253-51.359,20.277-76.164,21.628-88.1a12.969,12.969,0,0,0-8.977-13.9c-3.972-1.271-9.1-2.78-14.18-3.972-1.728-.457-3.5-.874-5.223-1.271a216.639,216.639,0,0,0-30.7-3.972c-1.529-.139-3.039-.219-4.568-.3-3-.159-5.958-.2-8.659-.2A14.6,14.6,0,0,0,132.163,193.9c.536,5.958.953,11.5,1.271,16.583.755,11.916.993,21.449.814,29.79a256.916,256.916,0,0,1-4.488,40.793Z",
    transform: "translate(-8.466 -95.176)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5297",
    "data-name": "Grupo 5297",
    transform: "translate(121.294 82.834)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6707",
    "data-name": "Trazado 6707",
    d: "M129.76,281.065l67.644,8.659c15.253-51.359,20.277-76.164,21.628-88.1a12.969,12.969,0,0,0-8.977-13.9c-3.972-1.271-9.1-2.78-14.18-3.972-1.728-.457-3.5-.874-5.223-1.271a216.639,216.639,0,0,0-30.7-3.972c-1.529-.139-3.039-.219-4.568-.3-3-.159-5.958-.2-8.659-.2A14.6,14.6,0,0,0,132.163,193.9c.536,5.958.953,11.5,1.271,16.583.755,11.916.993,21.449.814,29.79a256.916,256.916,0,0,1-4.488,40.793Z",
    transform: "translate(-129.76 -178.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6708",
    "data-name": "Trazado 6708",
    d: "M132.4,225.244c8.937-11.559,12.174-24.786,9.275-32.074l-10.089,2.264C132.4,207.311,132.623,216.883,132.4,225.244Z",
    transform: "translate(-6.661 -80.228)",
    fill: "#d81212",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6709",
    "data-name": "Trazado 6709",
    d: "M184.467,183.64c-1.748-.457-3.5-.874-5.223-1.271a219.749,219.749,0,0,0-30.724-3.972c-1.529-.119-3.039-.2-4.548-.278L141.33,178l1.986,3.476c.278.477,7.031,11.519,23.832,23.4l3.595,2.5,3.456-2.641a26.1,26.1,0,0,0,10.883-20.913Z",
    transform: "translate(2.943 -95.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6710",
    "data-name": "Trazado 6710",
    d: "M152.417,170.446c-.636,8.361-2.6,16.881-7.467,20.456,0,0,6.2,10.307,22.243,21.568,10.049-7.686,8.48-17.636,8.48-17.636-10.685-3.972-9.93-11.38-5.422-23.2l-8.341-4.488a5.462,5.462,0,0,0-9.493,3.3Z",
    transform: "translate(6.512 -107.651)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6711",
    "data-name": "Trazado 6711",
    d: "M158.154,167.152a5.462,5.462,0,0,0-9.394,2.542,33.762,33.762,0,0,0,14.6,14.915,36.165,36.165,0,0,1,3.118-12.969Z",
    transform: "translate(10.269 -107.654)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6712",
    "data-name": "Trazado 6712",
    d: "M142.568,168.98c4.151,16.146,5.561,23.058,15.431,29.79,14.836,10.208,33.763,1.589,34.5-15.451.7-15.352-6.2-39.184-23.435-42.6a22.74,22.74,0,0,0-26.494,28.261Z",
    transform: "translate(3.373 -132.401)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6713",
    "data-name": "Trazado 6713",
    d: "M186.343,145.269a87.187,87.187,0,0,1-33.763,18.609s12.333,26.235-10.744,19.622c-6.693-22.343,0-33.941,5.958-39.4C166.145,138.14,179.054,136.154,186.343,145.269Z",
    transform: "translate(0.689 -133.614)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6714",
    "data-name": "Trazado 6714",
    d: "M142.092,166.7a12.194,12.194,0,0,0,6.832,6.316c3.972,1.43,6.335-1.986,5.481-5.958-.775-3.555-3.793-8.6-7.944-8.341a5.462,5.462,0,0,0-4.369,7.984Z",
    transform: "translate(3.075 -114.211)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6715",
    "data-name": "Trazado 6715",
    d: "M131.457,228.033l-3.833,5.66c-.3.437.2.993.973,1.092l70.941,9.1c.616,0,1.152-.159,1.251-.536l1.39-5.958c0-.417-.4-.834-1.053-.933l-68.518-8.778a1.191,1.191,0,0,0-1.152.357Z",
    transform: "translate(-10.659 -46.235)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6716",
    "data-name": "Trazado 6716",
    d: "M134.827,236.68,133,236.442c-.357,0-.616-.278-.556-.5l1.867-7.765a.655.655,0,0,1,.755-.318l1.847.238c.357,0,.616.258.556.5l-1.867,7.746C135.542,236.581,135.2,236.72,134.827,236.68Z",
    transform: "translate(-5.828 -46.044)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6717",
    "data-name": "Trazado 6717",
    d: "M162.338,240.191l-1.827-.218c-.357,0-.616-.278-.556-.516l1.867-7.746c0-.218.4-.377.755-.338l1.847.238c.357,0,.616.278.556.5l-1.867,7.765C163.052,240.092,162.715,240.251,162.338,240.191Z",
    transform: "translate(21.298 -42.564)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6718",
    "data-name": "Trazado 6718",
    d: "M148.6,238.431l-1.827-.238c-.377,0-.636-.258-.576-.5l1.867-7.746c0-.238.4-.377.775-.338l1.827.238c.357,0,.616.278.576.5l-1.887,7.765C149.312,238.332,148.955,238.471,148.6,238.431Z",
    transform: "translate(7.73 -44.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6719",
    "data-name": "Trazado 6719",
    d: "M156.122,155.722c.238,1.331,1.152,2.284,1.986,2.105s1.37-1.37,1.112-2.7-1.172-2.284-1.986-2.105S155.923,154.391,156.122,155.722Z",
    transform: "translate(17.485 -119.837)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6720",
    "data-name": "Trazado 6720",
    d: "M163.688,154.28c.258,1.331,1.172,2.264,1.986,2.105s1.37-1.39,1.112-2.721-1.172-2.264-1.986-2.105S163.45,152.949,163.688,154.28Z",
    transform: "translate(24.932 -121.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6721",
    "data-name": "Trazado 6721",
    d: "M164,152.4l3.019-1.549S165.986,153.67,164,152.4Z",
    transform: "translate(25.296 -121.956)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6722",
    "data-name": "Trazado 6722",
    d: "M161.66,154.42a36.8,36.8,0,0,0,6.375,7.567,5.779,5.779,0,0,1-4.568,1.807Z",
    transform: "translate(22.989 -118.436)",
    fill: "#c3915c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6723",
    "data-name": "Trazado 6723",
    d: "M156.988,162.506a.4.4,0,0,0,.477.616,10.665,10.665,0,0,1,9.692,0,.4.4,0,0,0,.536-.139.417.417,0,0,0-.119-.556,11.479,11.479,0,0,0-10.466,0S157.107,162.466,156.988,162.506Z",
    transform: "translate(18.287 -111.786)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6724",
    "data-name": "Trazado 6724",
    d: "M154.1,155.025a.715.715,0,0,0,.278-.318,6.3,6.3,0,0,1,4.488-3.555.794.794,0,0,0,.7-.894.774.774,0,0,0-.874-.7,7.944,7.944,0,0,0-5.74,4.449.794.794,0,0,0,1.152,1.013Z",
    transform: "translate(14.32 -123.232)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6725",
    "data-name": "Trazado 6725",
    d: "M169.772,148.583l.1-.1a.794.794,0,0,0-.2-1.112,7.944,7.944,0,0,0-7.189-1.072.814.814,0,0,0-.437,1.033.794.794,0,0,0,1.033.437,6.276,6.276,0,0,1,5.68.914A.775.775,0,0,0,169.772,148.583Z",
    transform: "translate(23.318 -126.859)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6726",
    "data-name": "Trazado 6726",
    d: "M156.47,153.839l3.019-1.529S158.317,155.11,156.47,153.839Z",
    transform: "translate(17.871 -120.517)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6727",
    "data-name": "Trazado 6727",
    d: "M109.359,354.961a10.566,10.566,0,0,1-10.566-10.467c-.278-28.2,9.116-52.014,27.169-68.855,22.224-20.734,56.88-30.366,97.633-27.149,28.579,2.264,46.91-4.687,68.121-12.77,3.5-1.311,7.011-2.661,10.625-3.972a10.568,10.568,0,1,1,7.229,19.86c-3.515,1.271-6.931,2.582-10.327,3.873-21.628,8.222-43.971,16.7-77.316,14.081-34.755-2.761-63.712,4.886-81.546,21.529-13.9,12.869-20.675,30.764-20.456,53.206a10.566,10.566,0,0,1-10.466,10.665Z",
    transform: "translate(-39.006 -42.82)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6728",
    "data-name": "Trazado 6728",
    d: "M0,0H45.262A14.24,14.24,0,0,1,59.5,14.24V65.261A14.24,14.24,0,0,1,45.262,79.5H0V0Z",
    transform: "translate(314.704 223.709) rotate(159.88)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6729",
    "data-name": "Trazado 6729",
    d: "M0,0H45.262A14.24,14.24,0,0,1,59.5,14.24V65.261A14.24,14.24,0,0,1,45.262,79.5H0V0Z",
    transform: "translate(314.704 223.709) rotate(159.88)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6730",
    "data-name": "Trazado 6730",
    d: "M203.869,218.281l18.967-6.931,27.328,74.635L231.2,292.936a11.459,11.459,0,0,1-2.82-4.369l-23.832-65.122A11.32,11.32,0,0,1,203.869,218.281Z",
    transform: "translate(64.55 -62.302)",
    fill: "#d81212",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1597",
    "data-name": "Rect\\xE1ngulo 1597",
    width: 1.986,
    height: 13.227,
    transform: "translate(328.112 168.319) rotate(-20.12)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6731",
    "data-name": "Trazado 6731",
    d: "M252.4,232.493,245.7,214.182A16.206,16.206,0,0,0,230.511,203.6a15.888,15.888,0,0,0-5.521.973L212.915,209l-.7-1.867,12.095-4.429a17.874,17.874,0,0,1,6.2-1.092,18.232,18.232,0,0,1,17.06,11.916l6.693,18.311Z",
    transform: "translate(72.842 -71.906)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1598",
    "data-name": "Rect\\xE1ngulo 1598",
    width: 41.19,
    height: 93.125,
    rx: 5.62,
    transform: "matrix(-0.94, 0.34, -0.34, -0.94, 343.261, 218.845)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6732",
    "data-name": "Trazado 6732",
    d: "M227.937,219.813a5.958,5.958,0,1,1-7.626-3.555,5.958,5.958,0,0,1,7.626,3.555Z",
    transform: "translate(76.946 -57.816)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6733",
    "data-name": "Trazado 6733",
    d: "M235.408,240.205a5.958,5.958,0,1,1-3.086-3.363,5.958,5.958,0,0,1,3.086,3.363Z",
    transform: "translate(84.31 -37.713)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6734",
    "data-name": "Trazado 6734",
    d: "M165.386,288.655l-.159-.179c-3.1-3.1-6.375-6.474-9.334-9.93s-5.859-6.911-8.5-10.486a98.12,98.12,0,0,1-7.05-10.943,57.044,57.044,0,0,1-3.833-8.48c1.192-3.972,2.463-7.944,3.972-11.757,1.728-4.588,3.674-9.1,5.8-13.545s4.389-8.818,6.832-13.088c1.192-2.145,2.443-4.27,3.734-6.355l1.986-3.058c.616-.993,1.35-1.986,1.867-2.84l.218-.318a9.93,9.93,0,0,0-16.206-11.459c-.993,1.35-1.748,2.423-2.542,3.595s-1.509,2.344-2.264,3.515c-1.45,2.344-2.86,4.707-4.21,7.11a156.9,156.9,0,0,0-7.289,14.776c-1.112,2.5-1.986,5.064-3.118,7.626a64.936,64.936,0,0,0-2.681,7.825,146.625,146.625,0,0,0-4.151,16.067v.457a7.944,7.944,0,0,0,.3,4.349,65.1,65.1,0,0,0,7.606,14.379,95.767,95.767,0,0,0,9.811,11.916,122.548,122.548,0,0,0,11.1,10.029,118.1,118.1,0,0,0,12.254,8.56,4.925,4.925,0,0,0,5.958-7.745Z",
    transform: "translate(-19.783 -90.949)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6735",
    "data-name": "Trazado 6735",
    d: "M169.2,245.947l-.258-.516a12.313,12.313,0,0,0-8.679-6.752l-15.074-3.058-7.368,3.674c.794,8.262,12.591,13.207,12.591,13.207l3.356,3.833a6.951,6.951,0,0,0,9.215,1.092l3.972-2.84a6.911,6.911,0,0,0,2.244-8.639Z",
    transform: "translate(-0.518 -38.371)",
    fill: "#f0c08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6736",
    "data-name": "Trazado 6736",
    d: "M143.759,179.269c-8.361,3.833-17.259,17.1-17.259,17.1l17.874,33.465s20.317-23.415,18.609-35.133C161.593,184.751,154.4,174.384,143.759,179.269Z",
    transform: "translate(-11.68 -95.164)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5298",
    "data-name": "Grupo 5298",
    transform: "translate(114.82 82.858)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6737",
    "data-name": "Trazado 6737",
    d: "M143.759,179.269c-8.361,3.833-17.259,17.1-17.259,17.1l17.874,33.465s20.317-23.415,18.609-35.133C161.593,184.751,154.4,174.384,143.759,179.269Z",
    transform: "translate(-126.5 -178.022)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-36",
    transform: "translate(542.738 192.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6738",
    "data-name": "Trazado 6738",
    d: "M512.527,643.5c-17.5,0-34.7-3.595-43.037-14.478C430.007,577.39,430.365,473.52,430.7,373.007c.2-54.119,4.469-105.26-1.549-144.98-3.535-23.415-15.888-39.482-28.361-47.784-18.51-12.234-43.931-5.66-54.795-2.86a10.565,10.565,0,1,1-5.283-20.458c13.565-3.513,45.381-11.716,71.716,5.682,17.775,11.737,33.147,32.69,37.615,62.262,6.256,41.309,1.986,93.2,1.787,148.138-.338,96.978-.675,197.253,34.438,243.11,2.84,3.694,13.9,7.011,32.273,6.057,1.629,0,3.217-.179,4.786-.318a10.368,10.368,0,0,1-1.073-4.627,10.566,10.566,0,0,1,10.566-10.566c23.1,0,35.252,1.986,37.6,12.552.675,3.039,1.033,10.665-10.129,15.888C551.95,639.016,532.05,643.5,512.527,643.5Z",
    transform: "translate(-214.598 -79.089)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6739",
    "data-name": "Trazado 6739",
    d: "M317.568,426.778,296.02,418.3l11.36-37.357,21.568,8.461Z",
    transform: "translate(-250.854 146.754)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6740",
    "data-name": "Trazado 6740",
    d: "M310.063,398.75l24.309,9.533a1.489,1.489,0,0,1,.914,1.589L332.9,425.005a2.483,2.483,0,0,1-3.376,1.887c-6.1-2.522-15.65-6.693-23.376-9.732-4.747-1.867-13.783-4.846-20.357-7.428s-4.866-9.414-1.986-8.937c13.088,2.105,18.093-.139,23.316-2.085A3.972,3.972,0,0,1,310.063,398.75Z",
    transform: "translate(-265.413 164.018)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6741",
    "data-name": "Trazado 6741",
    d: "M326.217,389.42l-21.568-8.48L298.79,400.2l21.568,8.48Z",
    transform: "translate(-248.122 146.754)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6742",
    "data-name": "Trazado 6742",
    d: "M354.706,239.61s-19.5,96.4-26.95,143.947c-8.381,53.285-30.525,150.62-30.525,150.62l28.658,11.261s40.932-99.659,46.632-147.92C389.7,358.3,423.859,242.867,423.859,242.867Z",
    transform: "translate(-249.66 7.399)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6743",
    "data-name": "Trazado 6743",
    d: "M296.53,393.837l31.459,12.373,5.382-9.533L298.2,382.1Z",
    transform: "translate(-250.351 147.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6744",
    "data-name": "Trazado 6744",
    d: "M294.128,401.318a5.144,5.144,0,0,1-2.7-1.986,2.463,2.463,0,0,1,0-2.264,1.231,1.231,0,0,1,1.033-.794c2.085-.218,5.958,4.866,6.335,5.462a.4.4,0,0,1-.4.616A20.22,20.22,0,0,1,294.128,401.318Zm-1.053-4.151a.993.993,0,0,0-.516-.1c-.119,0-.258,0-.4.338a1.589,1.589,0,0,0,0,1.549c.576,1.053,2.562,1.986,5.442,2.463a15.609,15.609,0,0,0-4.528-4.25Z",
    transform: "translate(-255.654 161.867)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6745",
    "data-name": "Trazado 6745",
    d: "M296.008,403.536a.317.317,0,0,1-.159-.119c-1.271-1.509-3.059-6.177-1.986-7.785a1.311,1.311,0,0,1,1.569-.5,2.185,2.185,0,0,1,1.39,1.092c1.231,2.2-.159,6.852-.218,7.05a.417.417,0,0,1-.318.278.278.278,0,0,1-.278-.02Zm-.675-7.587h-.159c-.516-.119-.636,0-.7.179-.6.953.377,4.33,1.509,6.177a9.573,9.573,0,0,0,0-5.64A1.39,1.39,0,0,0,295.333,395.949Z",
    transform: "translate(-253.304 160.662)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6746",
    "data-name": "Trazado 6746",
    d: "M354.8,269c-10.8,13.386-15.074,47.506-15.034,75.946,7.289-20.079,15.65-45.579,23-68.736Z",
    transform: "translate(-207.715 36.378)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6747",
    "data-name": "Trazado 6747",
    d: "M385.2,425.156H362.038L358.96,386.23h23.157Z",
    transform: "translate(-188.793 151.97)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6748",
    "data-name": "Trazado 6748",
    d: "M372.342,404.85h26.116a1.45,1.45,0,0,1,1.43,1.152l3.317,14.935a2.482,2.482,0,0,1-2.463,3c-6.594-.119-16.981-.516-25.282-.516-5.124,0-14.617.536-21.668.536s-7.944-6.971-5.1-7.607c12.969-2.84,16.822-6.733,20.953-10.466A4.091,4.091,0,0,1,372.342,404.85Z",
    transform: "translate(-200.407 170.33)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6749",
    "data-name": "Trazado 6749",
    d: "M382.127,386.23H358.95l1.609,20.079h23.177Z",
    transform: "translate(-188.803 151.97)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6750",
    "data-name": "Trazado 6750",
    d: "M340.29,240.22s12.83,107.424,15.531,146.092c3.754,53.821,18.271,160.074,18.271,160.074h30.783s3.3-108.517-2.264-156.8c7.666-42.124,5.243-146.132,5.243-146.132Z",
    transform: "translate(-207.202 8)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6751",
    "data-name": "Trazado 6751",
    d: "M358.051,400.439h33.8l1.529-10.824L355.31,388.9Z",
    transform: "translate(-192.392 154.603)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6752",
    "data-name": "Trazado 6752",
    d: "M359.027,408.3a5.124,5.124,0,0,1-3.237-.854,2.482,2.482,0,0,1-.834-2.105,1.271,1.271,0,0,1,.7-1.132c1.867-.953,7.289,2.383,7.944,2.761a.4.4,0,0,1,.2.4.457.457,0,0,1-.318.338A19.854,19.854,0,0,1,359.027,408.3Zm-2.5-3.476a1.052,1.052,0,0,0-.516.1c-.1,0-.218.159-.238.457a1.589,1.589,0,0,0,.536,1.45c.914.775,3.118.874,5.958.3a16.047,16.047,0,0,0-5.68-2.3Z",
    transform: "translate(-192.753 169.526)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6753",
    "data-name": "Trazado 6753",
    d: "M361.668,409.637h-.2c-1.728-.953-5.1-4.627-4.747-6.514a1.291,1.291,0,0,1,1.271-1.033,2.125,2.125,0,0,1,1.688.5c1.986,1.609,2.363,6.455,2.383,6.653a.437.437,0,0,1-.179.377A.457.457,0,0,1,361.668,409.637Zm-3.4-6.812h-.179c-.516,0-.556.318-.576.417-.218,1.092,1.986,3.972,3.654,5.2a9.652,9.652,0,0,0-1.986-5.283,1.49,1.49,0,0,0-.914-.338Z",
    transform: "translate(-191.024 167.588)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6754",
    "data-name": "Trazado 6754",
    d: "M393.16,179.563h0l-18.549-.238c-6.236,0-12.433-.2-18.569-.3-1.867,0-3.694-.119-5.541-.2.119,0,.2-.218.3-.318,1.311-1.39,2.622-2.82,3.972-4.191q1.013-1.072,1.986-2.085c.616-.675,1.41-1.43,1.827-1.986l1.688-2.145a10.268,10.268,0,0,0-10.764-16.246l-3.674.993c-1.132.338-2.264.715-3.4,1.092-2.224.775-4.409,1.629-6.574,2.562a97.49,97.49,0,0,0-12.611,6.713,90.629,90.629,0,0,0-11.817,9,78.291,78.291,0,0,0-10.546,11.737,18.018,18.018,0,0,0-1.986,3.416,17.4,17.4,0,0,0,8.977,22.9l1.807.794a76.178,76.178,0,0,0,12.631,4.171c3.773.973,7.348,1.609,10.864,2.2s6.951,1.072,10.367,1.49,6.792.735,10.168,1.013c6.733.6,13.406.894,20.059,1.092s13.167.2,20.079-.119a20.694,20.694,0,0,0-.675-41.369Z",
    transform: "translate(-249.447 -79.48)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6755",
    "data-name": "Trazado 6755",
    d: "M378.186,203.117c-16.027,18.271-54.6,11.44-54.6,11.44l2.125-45.52a200.586,200.586,0,0,1,40.237-4.667C388.593,164.33,391.016,188.461,378.186,203.117Z",
    transform: "translate(-223.669 -66.79)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6756",
    "data-name": "Trazado 6756",
    d: "M334.929,189.1c-.953,7.348-1.986,17.239-2.6,30.545-8.361,42.3-11.479,72.272-4.091,94.138,5.839,7.209,81.924,5.819,95.607,4.429,7.944-19.662,8.778-76.1,9.712-123.551a27.348,27.348,0,0,0-22.74-27.447,183.688,183.688,0,0,0-51.875-1.748A27.328,27.328,0,0,0,334.929,189.1Z",
    transform: "translate(-223.191 -66.77)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6757",
    "data-name": "Trazado 6757",
    d: "M366.71,191.37c.258,14.458,10.744,37.556,22.541,49.273.715-12.214,1.172-25.461,1.529-38.827Z",
    transform: "translate(-181.151 -40.167)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6758",
    "data-name": "Trazado 6758",
    d: "M441.337,242.334l-.675-1.589a150.926,150.926,0,0,0-9.712-19.2c-3.535-5.958-7.348-11.579-11.3-17s-8.143-10.605-12.433-15.65c-2.185-2.5-4.349-5-6.633-7.428l-3.436-3.615-3.654-3.694a20.694,20.694,0,0,0-29.949,28.539l.6.655L375.8,216.317c3.972,4.409,7.765,8.9,11.539,13.366,1.827,2.244,3.714,4.488,5.422,6.772s3.515,4.488,5.223,6.752c2.463,3.436,4.846,6.852,6.971,10.208a50.992,50.992,0,0,1-1.231,5.025,144.327,144.327,0,0,1-5.025,14.18c-1.986,4.906-4.091,9.93-6.276,14.875s-4.528,10.109-6.613,15.074l-.2.437a10.447,10.447,0,0,0,16.683,11.737,164.858,164.858,0,0,0,12.452-12.87,158.864,158.864,0,0,0,11.181-14.1c1.768-2.483,3.456-5.064,5.124-7.746a89.769,89.769,0,0,0,4.747-8.441,78.954,78.954,0,0,0,4.171-9.771,44.471,44.471,0,0,0,2.542-13.326,14.875,14.875,0,0,0-1.172-6.157Z",
    transform: "translate(-189.484 -63.029)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6759",
    "data-name": "Trazado 6759",
    d: "M379.814,166.093c26.792,4.588,44.249,40.853,44.249,40.853L391.77,241.681s-18.609-18.947-29.79-36.5C349.924,186.072,360.629,162.836,379.814,166.093Z",
    transform: "translate(-190.839 -65.395)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6760",
    "data-name": "Trazado 6760",
    d: "M346.728,158.757c-4.488-7.527-5.958-17.874,2.264-28.42a8.341,8.341,0,0,1-8.182-3.972,49.233,49.233,0,0,1,31.955-11.122c24.031,0,25.818,9.275,25,15.61,16.444,1.053,28.44,43.812-13.247,51.379C360.67,157.109,346.728,158.757,346.728,158.757Z",
    transform: "translate(-206.689 -115.237)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6761",
    "data-name": "Trazado 6761",
    d: "M369.539,130.984s6.693-6.832-1.629-15.094a11.2,11.2,0,0,1,7.825,7.785C376.907,128.481,373.669,132.334,369.539,130.984Z",
    transform: "translate(-179.968 -114.593)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6762",
    "data-name": "Trazado 6762",
    d: "M383.105,146.34c-.636,13.167-1.827,28.142.377,38.648-3.416,5.382-12.154,11.579-27.8,12.969-5.561-3.158-12.909-10.883-10.347-14.855,6.653-4.27,9.473-17.2,7.567-26.871Z",
    transform: "translate(-202.75 -84.568)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6763",
    "data-name": "Trazado 6763",
    d: "M371.481,147.59,348.86,155a35.487,35.487,0,0,1,.1,12.472c6.753-.218,16.107-5.3,19.622-10.069a12.552,12.552,0,0,0,2.9-9.811Z",
    transform: "translate(-198.752 -83.336)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6764",
    "data-name": "Trazado 6764",
    d: "M392.268,150.112c-4.19,16.146-5.819,25.818-15.709,32.591-14.875,10.188-33.584-1.231-34.319-18.291-.636-15.372,6.316-39.2,23.594-42.6a22.76,22.76,0,0,1,26.434,28.3Z",
    transform: "translate(-205.319 -109.193)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6765",
    "data-name": "Trazado 6765",
    d: "M369.967,124.2c-7.09,5.045-15.888,26.414,1.986,34.994C388,145.093,383.85,124.2,369.967,124.2Z",
    transform: "translate(-186.355 -106.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6766",
    "data-name": "Trazado 6766",
    d: "M389.6,132.6c3.039-14.061-32.452-21.33-43.693-4.905C342.09,137.587,387.451,146.326,389.6,132.6Z",
    transform: "translate(-201.892 -112.239)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6767",
    "data-name": "Trazado 6767",
    d: "M360.465,145.939h0a34.319,34.319,0,0,0-11.678-2.959.417.417,0,0,0-.417.437.576.576,0,0,0,.536.477,33.265,33.265,0,0,1,11.2,2.82.477.477,0,0,0,.616-.218.417.417,0,0,0-.258-.556Z",
    transform: "translate(-199.235 -87.881)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6768",
    "data-name": "Trazado 6768",
    d: "M377.625,150.8a15.888,15.888,0,0,1-11.042,4.985c-5.561.119-6.971-5.184-4.29-9.712,2.423-3.972,8.222-9.056,13.267-7.031S381.121,147,377.625,150.8Z",
    transform: "translate(-186.803 -92.222)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6769",
    "data-name": "Trazado 6769",
    d: "M356.041,137.016c-.258,1.331-1.172,2.284-1.986,2.105s-1.351-1.39-1.092-2.721,1.172-2.264,1.986-1.986S356.3,135.626,356.041,137.016Z",
    transform: "translate(-194.771 -96.376)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6770",
    "data-name": "Trazado 6770",
    d: "M348.48,135.592c-.258,1.331-1.172,2.264-1.986,2.105s-1.37-1.39-1.112-2.721,1.172-2.284,1.986-2.105S348.659,134.261,348.48,135.592Z",
    transform: "translate(-202.244 -97.871)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6771",
    "data-name": "Trazado 6771",
    d: "M353.51,135a48.718,48.718,0,0,1-8.58,10.149c1.986,2.641,6.375,2.125,6.375,2.125Z",
    transform: "translate(-202.627 -95.75)",
    fill: "#d0a77d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6772",
    "data-name": "Trazado 6772",
    d: "M353.7,131.82a.854.854,0,0,1,.794.238,6.335,6.335,0,0,0,5.283,2.284.814.814,0,0,1,.914.675.775.775,0,0,1-.675.894,7.944,7.944,0,0,1-6.713-2.8.774.774,0,0,1,0-1.112,1.012,1.012,0,0,1,.4-.179Z",
    transform: "translate(-194.599 -98.905)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6773",
    "data-name": "Trazado 6773",
    d: "M344.864,131.174a.715.715,0,0,1-.417-.258.795.795,0,0,1,.139-1.132,7.944,7.944,0,0,1,7.09-1.529.814.814,0,0,1,.516,1.013.854.854,0,0,1-1.013.5h0a6.335,6.335,0,0,0-5.62,1.271.7.7,0,0,1-.7.139Z",
    transform: "translate(-203.276 -102.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6774",
    "data-name": "Trazado 6774",
    d: "M385.32,235.619l-17.06-.119,8.818,19.582s14.558-3.118,13.763-11.022Z",
    transform: "translate(-179.623 3.346)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6775",
    "data-name": "Trazado 6775",
    d: "M364.249,248.945l2.8,5.521a6.633,6.633,0,0,0,8.361,3.138l6.335-2.522L372.927,235.5l-6.772,5.164A6.614,6.614,0,0,0,364.249,248.945Z",
    transform: "translate(-184.29 3.346)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6776",
    "data-name": "Trazado 6776",
    d: "M316.661,301.247a10.586,10.586,0,0,1-7.567-17.874c7.587-7.825,14.438-13.9,20.476-19.2,14.577-12.85,19.6-17.874,19.125-27.506a96.76,96.76,0,0,0-3.773-17.517c-4.349-15.988-9.275-34.08-.834-48.6,4.528-7.805,12.214-13.147,22.859-15.888a10.565,10.565,0,1,1,5.283,20.458c-7.488,1.984-9.3,5.023-9.931,6.055-3.972,6.852-.139,21.032,2.959,32.412a110.315,110.315,0,0,1,4.488,22.045c.993,20.357-11.022,30.962-26.255,44.388-5.74,5.084-12.274,10.844-19.3,18.073A10.506,10.506,0,0,1,316.661,301.247Z",
    transform: "translate(-240.831 -76.7)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6777",
    "data-name": "Trazado 6777",
    d: "M324.777,154l16.524-4.23L337.448,170.9s-14.875.457-15.987-7.388Z",
    transform: "translate(-225.769 -81.186)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6778",
    "data-name": "Trazado 6778",
    d: "M344.961,160.971l-1.271,5.521a6.931,6.931,0,0,1-7.706,5.3l-6.474-.894,3.853-21.131,7.587,3.277A6.931,6.931,0,0,1,344.961,160.971Z",
    transform: "translate(-217.831 -81.186)",
    fill: "#f5d2ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1599",
    "data-name": "Rect\\xE1ngulo 1599",
    width: 10.923,
    height: 93.125,
    rx: 2.59,
    transform: "translate(65.837 185.709) rotate(44.99)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1600",
    "data-name": "Rect\\xE1ngulo 1600",
    width: 10.923,
    height: 93.125,
    rx: 2.59,
    transform: "translate(96.36 216.197) rotate(45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6779",
    "data-name": "Trazado 6779",
    d: "M0,0H58.369a14.24,14.24,0,0,1,14.24,14.24V65.261A14.24,14.24,0,0,1,58.369,79.5H0Z",
    transform: "translate(22.116 211.603) rotate(-45)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6780",
    "data-name": "Trazado 6780",
    d: "M0,0H58.369a14.24,14.24,0,0,1,14.24,14.24V65.261A14.24,14.24,0,0,1,58.369,79.5H0Z",
    transform: "translate(22.116 211.603) rotate(-45)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6781",
    "data-name": "Trazado 6781",
    d: "M298.679,214.56l-14.3,14.28L340.6,285.064l14.28-14.3a11.4,11.4,0,0,0-2.761-4.409L303.088,217.42a11.4,11.4,0,0,0-4.409-2.86Z",
    transform: "translate(-262.331 -17.301)",
    fill: "#d81212",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1601",
    "data-name": "Rect\\xE1ngulo 1601",
    width: 23.773,
    height: 93.125,
    rx: 5.62,
    transform: "translate(10.724 213.254) rotate(-45)",
    fill: "#d81212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound404);
export default __webpack_public_path__ + "static/media/not-found-404.29585f2f44618cc6c0680f1521da7dcb.svg";
export { ForwardRef as ReactComponent };